export default function undo (history, nodes) {
  for (let i = 0, l = nodes.length; i < l; i++) {
    const node = nodes[i]
    if (node.type === 'symbol') {
      history.find(node.id).undo()
      undo(history, node.nodes)
    }
  }
}
